<template lang="pug">
.app
  router-view(v-slot="{ Component }")
    transition(
      name="fade"
      mode="out-in"
    )
      component(:is="Component")
  UiDialogs
  UiToastProvider
</template>

<script>
export default {
  name: "App",
};
</script>
